export default "__VITE_ASSET__4ocfw_Wl__"